import axios from "axios";

export const getAccessToken = (): string | null => {
  return localStorage.getItem("accessToken");
};

export const syncAuthHeader = (): void => {
  const accessToken = getAccessToken();
  const commonHeaders = axios.defaults.headers.common as Record<string, string>;

  if (accessToken) {
    commonHeaders.Authorization = `Bearer ${accessToken}`;
  } else {
    delete commonHeaders.Authorization;
  }
};

export const storeAccessToken = (accessToken?: string): void => {
  if (accessToken) localStorage.setItem("accessToken", accessToken);
  syncAuthHeader();
};

export const clearAuthData = (): void => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("memberData");
  syncAuthHeader();
};
